import { lazy, Suspense } from "react"

import { Footer } from "./components/Footer"
import { HeroSection } from "./components/HeroSection"
import { Navbar } from "./components/Navbar"

const BackToTop = lazy(() =>
  import("./components/BackToTop").then((m) => ({ default: m.BackToTop })),
)
const SmoothScroll = lazy(() =>
  import("@/shared/components/SmoothScroll").then((m) => ({
    default: m.SmoothScroll,
  })),
)

const TrustMarqueeSection = lazy(() =>
  import("./components/TrustMarqueeSection").then((m) => ({ default: m.TrustMarqueeSection })),
)
const HowItWorksSection = lazy(() =>
  import("./components/HowItWorksSection").then((m) => ({ default: m.HowItWorksSection })),
)
const DifferentialsSection = lazy(() =>
  import("./components/DifferentialsSection").then((m) => ({ default: m.DifferentialsSection })),
)
const UseCasesSection = lazy(() =>
  import("./components/UseCasesSection").then((m) => ({ default: m.UseCasesSection })),
)
const AssetsRailsSection = lazy(() =>
  import("./components/AssetsRailsSection").then((m) => ({ default: m.AssetsRailsSection })),
)
const SecuritySection = lazy(() =>
  import("./components/SecuritySection").then((m) => ({ default: m.SecuritySection })),
)
const APISection = lazy(() =>
  import("./components/APISection").then((m) => ({ default: m.APISection })),
)
const PricingSection = lazy(() =>
  import("./components/PricingSection").then((m) => ({ default: m.PricingSection })),
)
const FAQSection = lazy(() =>
  import("./components/FAQSection").then((m) => ({ default: m.FAQSection })),
)
const ContactSection = lazy(() =>
  import("./components/ContactSection").then((m) => ({ default: m.ContactSection })),
)
const FinalCTASection = lazy(() =>
  import("./components/FinalCTASection").then((m) => ({ default: m.FinalCTASection })),
)

function SectionFallback({ minHeight = 480 }: { minHeight?: number }) {
  return <div aria-hidden="true" style={{ minHeight: `${minHeight}px` }} />
}

function MarqueeFallback() {
  return <div aria-hidden="true" style={{ minHeight: "200px" }} />
}

export default function HomePage() {
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-mesa-primary focus:px-4 focus:py-2 focus:text-[13px] focus:font-medium focus:text-primary-foreground focus:shadow-lg focus:outline-none"
      >
        Pular para o conteúdo principal
      </a>
      <Navbar />
      <main
        id="main"
        className="relative min-h-screen bg-background text-foreground"
      >
        <HeroSection />
        <Suspense fallback={<MarqueeFallback />}>
          <TrustMarqueeSection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={700} />}>
          <HowItWorksSection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={520} />}>
          <DifferentialsSection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={600} />}>
          <UseCasesSection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={700} />}>
          <AssetsRailsSection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={600} />}>
          <SecuritySection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={600} />}>
          <APISection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={380} />}>
          <PricingSection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={600} />}>
          <FAQSection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={600} />}>
          <ContactSection />
        </Suspense>
        <Suspense fallback={<SectionFallback minHeight={420} />}>
          <FinalCTASection />
        </Suspense>
        <Footer />
        <Suspense fallback={null}>
          <BackToTop />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <SmoothScroll />
      </Suspense>
    </>
  )
}
